/* src/app/controls/pagination/pagination.component.css */
/*# sourceMappingURL=pagination.component.css.map */
